import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import langInvestWordLang from '../langs/langInvestWordLang';

type CDateUpdatedAtomProps = {
	date?: Date | null;
	isEstimated?: boolean;
	dateOnly?: boolean;
};
const CDateUpdatedAtom = (props: CDateUpdatedAtomProps) => {
	const { date, isEstimated, dateOnly } = props;
	const { t } = useTranslation();
	return (
		<>
			{!dateOnly ? (
				<>
					{isEstimated === true
						? t(langInvestWordLang.data_estimated_on.tag)
						: isEstimated === false
						? t(langInvestWordLang.data_audited_on.tag)
						: t(langInvestWordLang.data_updated_on.tag)}{' '}
				</>
			) : (
				''
			)}
			<>
				{date
					? `${moment(date).format('DD/MM/YYYY')} ${
							moment(date).format('HH:mm') !== '00:00'
								? `${t(langInvestWordLang.date_at.tag)} ${moment(date).format('HH:mm')}`
								: ''
					  }`
					: 'n.c.'}
			</>
		</>
	);
};

CDateUpdatedAtom.defaultProps = {
	dateOnly: false,
};

export default CDateUpdatedAtom;
